import React from 'react';
import { createPortal } from 'react-dom';
import { DropdownButton, DropdownWrapper } from './styles';
import { Editor } from '@tiptap/react';

interface TiptapDropdownProps {
  dropdownRef: React.RefObject<HTMLDivElement>;
  dropdownCoords: { top: number; left: number };
  editor: Editor | null;
  setDropdownOpen: (value: boolean) => void;
}

const TiptapDropdown: React.FC<TiptapDropdownProps> = ({ dropdownRef, dropdownCoords, editor, setDropdownOpen }) => {
  return createPortal(
    <DropdownWrapper ref={dropdownRef} top={dropdownCoords.top} left={dropdownCoords.left}>
      <DropdownButton
        onClick={() => {
          editor?.chain().focus().setHeading({ level: 1 }).run();
          setDropdownOpen(false);
        }}>
        Huge
      </DropdownButton>
      <DropdownButton
        onClick={() => {
          editor?.chain().focus().setHeading({ level: 2 }).run();
          setDropdownOpen(false);
        }}>
        Large
      </DropdownButton>
      <DropdownButton
        onClick={() => {
          editor?.chain().focus().setParagraph().run();
          setDropdownOpen(false);
        }}>
        Normal
      </DropdownButton>
      <DropdownButton
        onClick={() => {
          editor?.chain().focus().setHeading({ level: 4 }).run();
          setDropdownOpen(false);
        }}>
        Small
      </DropdownButton>
    </DropdownWrapper>,
    document.body
  );
};

export default TiptapDropdown;
